import _classCallCheck from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import { BaseTransformer } from './BaseTransformer';
export var TeamMemberTransformer = /*#__PURE__*/function (_BaseTransformer) {
  _inherits(TeamMemberTransformer, _BaseTransformer);
  var _super = _createSuper(TeamMemberTransformer);
  function TeamMemberTransformer() {
    _classCallCheck(this, TeamMemberTransformer);
    return _super.apply(this, arguments);
  }
  _createClass(TeamMemberTransformer, null, [{
    key: "fetch",
    value: function fetch(data) {
      return {
        team: data.team,
        recordOwner: data.record_owner,
        recordId: data.record_id
      };
    }
  }, {
    key: "send",
    value: function send(data) {
      return {
        record_owner: data.recordOwner,
        team: data.team,
        record_id: data.recordId
      };
    }
  }]);
  return TeamMemberTransformer;
}(BaseTransformer);